<script lang="ts" setup>
import { RoleEnum } from "~/types/User";
import { Dialog, DialogTrigger, DialogContent, DialogClose, DialogHeader } from '~/components/ui/dialog';
import { Button } from '~/components/ui/button';

const {t} = useI18n()
const route = useRoute();
const userStore = useUserStore()

const props = defineProps({
    class: {
        type: String,
    }
})

const open = ref(false)

const menus = computed(() => {
    return [
        {
            title: t('Profile Settings'),
            items: [
                {
                    name: t('Profile Settings'),
                    link: '/office/profile',
                    icon: 'ri:user-line',
                    role: [RoleEnum.MASTER, RoleEnum.CUSTOMER]
                },
                {
                    name: t('Portfolio'),
                    link: '/office/portfolio',
                    icon: 'ri:grid-line',
                    role: [RoleEnum.MASTER]
                },
            ]
        },
        {
            title: t('App'),
            items: [
                {
                    name: t('Notification Settings'),
                    link: '/office/profile/notification-settings',
                    icon: 'ri:notification-badge-line',
                    role: [RoleEnum.MASTER, RoleEnum.CUSTOMER]
                },
                {
                    name: t('Privacy & Security'),
                    link: '/office/profile/privacy-security',
                    icon: 'ri:lock-line',
                    role: [RoleEnum.MASTER, RoleEnum.CUSTOMER]
                },
            ]
        }
    ]
})

watch(
    () => route.path,
    () => {
        open.value = false
    },
);

</script>

<template>
    <Dialog v-model:open="open">
        <DialogTrigger>
            <slot/>
        </DialogTrigger>
        <DialogContent class="ys-modal-dialog w-full gap-0" :class="class">
            <DialogHeader class="px-4 py-5 mb-6">

                <p class="mb-1 text-center uppercase text-[13px] tracking-widest">{{ $t('Profile') }}</p>

                <DialogClose class="absolute top-4 ltr:right-4 rtl:left-4">
                    <Icon name="ri:close-line" size="20px" class="text-gray-500 translate-all hover:text-gray-700"/>
                </DialogClose>
            </DialogHeader>

            <div class="px-5 grid gap-10">
                <div v-for="section in menus" class="ys-second-menu-tabs">
                    <p class="font-bold text-lg">{{ section.title }}</p>
                    <nav class="mt-4">
                        <template v-for="item in section.items">
                            <NuxtLink
                                v-if="item.role.includes(userStore.currentRole as RoleEnum)"
                                :to="item.link"
                                class="flex justify-start items-center my-1 py-2.5"
                                :class="{
                                    'text-primary-500': route.path === item.link
                                 }">
                                <Icon size="24" class="menu-item-icon ltr:mr-3 rtl:ml-3" :name="item.icon"/>
                                {{ item.name }}
                                <Icon size="18" class="ltr:ml-auto rtl:mr-auto rtl:rotate-180"
                                      name="ri:arrow-right-s-line"/>
                            </NuxtLink>
                        </template>
                        <!-- <NuxtLink to="/" class="ys-second-menu-tabs-link flex justify-start my-1"
                          value="Contact Information">
                          <Icon size="18" class="menu-item-icon ltr:mr-1 rtl:ml-1" name="ri:contacts-book-line" />
                          {{ $t("Contact Information") }}
                          <Icon size="18" class="ltr:ml-auto rtl:mr-auto rtl:rotate-180 hidden-icon"
                            name="ri:arrow-right-s-line" />
                        </NuxtLink>
                        <NuxtLink to="/" class="ys-second-menu-tabs-link flex justify-start my-1" value="Role">
                          <Icon size="18" class="menu-item-icon ltr:mr-1 rtl:ml-1" name="ri:user-settings-line" />
                          {{ $t("Role") }}
                          <Icon size="18" class="ltr:ml-auto rtl:mr-auto rtl:rotate-180 hidden-icon"
                            name="ri:arrow-right-s-line" />
                        </NuxtLink>
                        <NuxtLink to="/" class="ys-second-menu-tabs-link flex justify-start my-1"
                          value="Regional Preferences">
                          <Icon size="18" class="menu-item-icon ltr:mr-1 rtl:ml-1" name="ri:global-line" />
                          {{ $t("Regional Preferences") }}
                          <Icon size="18" class="ltr:ml-auto rtl:mr-auto rtl:rotate-180 hidden-icon"
                            name="ri:arrow-right-s-line" />
                        </NuxtLink> -->
                    </nav>
                </div>
            </div>

            <div class="mt-auto flex justify-center mb-6">
                <Button @click="userStore.logout" variant="link" class="text-gray-400">{{ $t('Log Out') }}</Button>
            </div>
        </DialogContent>
    </Dialog>
</template>

<style scoped lang="scss">
.ys-second-menu-tabs-link {
    padding: 8px;
    gap: 6px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: -0.006em;
    text-align: left;
    color: rgba(82, 88, 102, 1);
    @media(max-width: 860px) {
        width: 100%;
    }

    .hidden-icon {
        display: none;
        width: 20px;
        height: 20px;
        gap: 8px;
        border-radius: 24px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0 2px 4px 0 rgba(27, 28, 29, 0.04);
    }

    &:hover {
        color: rgba(10, 13, 20, 1);
        background: rgba(246, 248, 250, 1);
    }
}


[data-state="active"] {
    color: rgba(10, 13, 20, 1);
    background: rgba(246, 248, 250, 1);

    .hidden-icon {
        display: block;
    }

    .menu-item-icon {
        color: rgba(45, 159, 117, 1);
    }
}

</style>